export const isHostNameMainDomain = () => window.location.hostname.endsWith(process.env.MAIN_DOMAIN)

export const extractSlug = () => {
  const hostname = window.location.hostname
  return hostname.substring(0, hostname.indexOf(process.env.MAIN_DOMAIN))
}

export const buildImageFromId = (imageSlug: string) => {
  return imageSlug && `${process.env.REACT_APP_API_SERVER}${imageSlug}`
}
